import React from "react";
import { EditOutlined } from "@ant-design/icons";
import {
  Avatar,
  Button,
  Card,
  Col,
  Layout,
  List,
  Row,
  Tabs,
  TabsProps,
  Typography,
  Collapse,
  Pagination,
  Spin,
  Skeleton,
} from "antd";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getHistory } from "../../Redux/Slice/HistorySlice";
import { useKeycloak } from "@react-keycloak/web";
import { gpuserverIp, serverIp } from "../../utils";
const { Content } = Layout;
const { Title, Text } = Typography;

const { Panel } = Collapse;

const History = ({
  historyAudioRef,
  historyVideoRef,
  currentPage,
  setCurrentPage,
}) => {
  const itemsPerPage = 5;
  const { keycloak } = useKeycloak();

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handleTabChange = () => {
    setCurrentPage(1);
  };

  const { history: data, loading: historyLoading } = useSelector(
    (state: any) => state.history.getHistory
  );

  const filterDataByType = (type: string) =>
    data.filter((item) => item.gen_type === type);

  const getCurrentPageData = (filteredData: typeof data) => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredData.slice(startIndex, endIndex);
  };

  const [activeKey, setActiveKey] = useState<string | null>(null);

  const handlePanelChange = (key: string | string[]) => {
    if (Array.isArray(key)) {
      // Handle cases where `key` might be an array
      key = key.length ? key[0] : null;
    }

    // If the panel is closing, stop the audio
    if (activeKey && activeKey !== key && historyAudioRef.current) {
      historyAudioRef.current.pause();
      historyAudioRef.current.currentTime = 0; // Reset the audio
    }

    if (activeKey && activeKey !== key && historyVideoRef.current) {
      historyVideoRef.current.pause();
      historyVideoRef.current.currentTime = 0; // Reset the audio
    }

    if ((key === undefined || key || null) && historyAudioRef.current) {
      historyAudioRef.current.pause();
      historyAudioRef.current.currentTime = 0;
    }

    if ((key === undefined || key || null) && historyVideoRef.current) {
      historyVideoRef.current.pause();
      historyVideoRef.current.currentTime = 0; // Reset the audio
    }

    setActiveKey(key as string | null);
  };

  const renderCollapseContent = (type: "video" | "audio") => {
    const filteredData = filterDataByType(type);
    return (
      <>
        {filteredData.length ? (
          <>
            {historyLoading ? (
              <Skeleton active />
            ) : (
              <>
                <Collapse
                  accordion
                  activeKey={activeKey}
                  onChange={handlePanelChange}
                >
                  {getCurrentPageData(filteredData)?.map((item) => (
                    <Panel
                      header={`${type === "video" ? "🎥" : "🎵"} ${item.name}`}
                      key={item._id.$oid}
                    >
                      <Card style={{ textAlign: "center" }}>
                        {type === "video" ? (
                          <video ref={historyVideoRef} width="100%" controls>
                            <source
                              src={item.path}
                              type="video/mp4"
                            />
                            Your browser does not support the video tag.
                          </video>
                        ) : (
                          <audio ref={historyAudioRef} controls>
                            <source
                              src={item.path}
                              type="audio/wav"
                            />
                            Your browser does not support the audio element.
                          </audio>
                        )}
                        <p style={{ marginTop: 10 }}>
                          <strong>Created:</strong>{" "}
                          {new Date(
                            item.createdTime?.$date
                          ).toLocaleDateString()}
                        </p>
                      </Card>
                    </Panel>
                  ))}
                </Collapse>
                <Pagination
                  current={currentPage}
                  pageSize={itemsPerPage}
                  total={filteredData.length}
                  onChange={handlePageChange}
                  showSizeChanger={false}
                  style={{ textAlign: "center", marginTop: 16 }}
                />
              </>
            )}
          </>
        ) : (
          <Row justify={"center"}>
            <Title>Nothing to Show</Title>
          </Row>
        )}
      </>
    );
  };

  const tabItems = [
    {
      key: "1",
      label: "Videos",
      children: <Card>{renderCollapseContent("video")}</Card>,
    },
    {
      key: "2",
      label: "Audios",
      children: <Card>{renderCollapseContent("audio")}</Card>,
    },
  ];

  return (
    <>
      {keycloak.authenticated &&
        (historyLoading ? (
          <Skeleton active />
        ) : data.length ? (
          <>
            <Title>Content History</Title>
            <Tabs
              items={tabItems}
              onChange={() => handleTabChange()}
              style={{ height: "500px", overflowY: "auto" }}
            />
          </>
        ) : (
          <Row justify={"center"}>
            <Title>Nothing to Show</Title>
          </Row>
        ))}
    </>
  );
};

export default History;
